import { createApp, h } from 'vue'
import { createInertiaApp, Link, router } from '@inertiajs/vue3'
import * as Fathom from 'fathom-client'
import { t, tt } from '@/Support/lang'
import { createPinia } from 'pinia'
import { modal } from 'inertia-modal'
// import {
//   defaultConfig as formKitDefaultConfig,
//   plugin as formKitPlugin,
// } from '@formkit/vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import '../css/app.css'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import _ from 'lodash'
import axios from 'axios'
import AppLayout from '@/Layouts/App/AppLayout.vue'
import { VueSvgIconPlugin } from '@yzfe/vue3-svgicon'
import '@yzfe/svgicon/lib/svgicon.css'
import { addIcons, OhVueIcon } from 'oh-vue-icons'
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from 'vue3-touch-events'
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { i18nVue } from 'laravel-vue-i18n'
import dayjs from 'dayjs'
import 'dayjs/locale/es'
import 'dayjs/locale/en'
import 'dayjs/locale/it'
import utc from 'dayjs/plugin/utc'
import cronLight from '@vue-js-cron/light'
import '@vue-js-cron/light/dist/light.css'
import cronCore from '@vue-js-cron/core'
import PrimeVue from 'primevue/config'
import { allIcons } from './icons'
import 'quill/dist/quill.snow.css'
import 'quill-table-up/index.css'
import '@/Support/Editor/quill-setup'

addIcons(...Object.values(allIcons))

window._ = _
window.axios = axios
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT,
  wssPort: import.meta.env.VITE_REVERB_PORT,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],
})

const siteName = import.meta.env.APP_NAME ?? 'Spatium'

Fathom.load(import.meta.env.VITE_FATHOM_SITE_ID, { manual: true })
router.on('navigate', () => Fathom.trackPageview())

function resolvePageComponentModal(name: string, pages: Record<string, any>) {
  for (const path in pages) {
    if (path.endsWith(`${name.replace('.', '/')}.vue`)) {
      return typeof pages[path] === 'function' ? pages[path]() : pages[path]
    }
  }

  throw new Error(`Page not found: ${name}`)
}

createInertiaApp({
  title: title => `${title} - ${siteName}`,
  resolve: name => {
    const page = resolvePageComponent(
      `./Pages/${name}.vue`,
      import.meta.glob('./Pages/**/*.vue'),
    )
    page.then(module => {
      if (module.default.layout === undefined && name.startsWith('App/')) {
        module.default.layout = AppLayout
      }
    })

    return page
  },
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
    app.config.globalProperties.route = route
    app.config.globalProperties.__ = t
    app.config.globalProperties.___ = tt
    app
      .use(i18nVue, {
        lang: window.currentLang,
        resolve: async lang => {
          const langs = import.meta.glob('../../lang/public/app/*.json')
          return await langs[`../../lang/public/app/${lang}.json`]()
        },
      })
      .use(modal, {
        resolve: name =>
          resolvePageComponentModal(name, import.meta.glob('./Pages/**/*.vue')),
      })
      .use(plugin)
      // .directive('tooltip', VTooltip)
      .use(createPinia())
      // .use(formKitPlugin, formKitDefaultConfig)
      .use(VueSvgIconPlugin, {
        tagName: 'icon',
      })
      .use<Vue3TouchEventsOptions>(Vue3TouchEvents)
      .use(FloatingVue)
      .use(cronLight)
      .use(cronCore)
      .use(PrimeVue, {
        unstyled: true,
      })
      .component('v-icon', OhVueIcon)
      .component('VIcon', OhVueIcon)
      .component('Link', Link)
      .component('InertiaLink', Link)
      .mount(el)
  },
  progress: {
    color: '#4B5563',
  },
})

dayjs.extend(utc)
dayjs.locale(window.currentLang)
